import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {ModelGroup} from './model-group.model';
import {AuthService} from '../auth/auth.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ModelGroupService {

  constructor(private authService: AuthService, private httpClient: HttpClient) {
  }

  findAll(): Observable<Array<ModelGroup>> {
    return this.httpClient.get<Array<ModelGroup>>(`${environment.baseUrl}/modelGroup`,
      {headers: this.authService.getHeaders()});
  }

  findByMakeName(makeName: string): Observable<Array<ModelGroup>> {
    const headers: HttpHeaders = this.authService.getHeaders();
    return this.httpClient.get<Array<ModelGroup>>(`${environment.baseUrl}/modelGroup/findByMakeName/${makeName}`, {
      headers
    });
  }

  findByCode(code: string): Observable<ModelGroup> {
    const headers: HttpHeaders = this.authService.getHeaders();
    return this.httpClient.get<ModelGroup>(`${environment.baseUrl}/modelGroup/findByCode/${code}`, {
      headers
    });
  }

  save(modelGroup: ModelGroup): Observable<ModelGroup> {
    const headers: HttpHeaders = this.authService.getHeaders();
    return this.httpClient.post<ModelGroup>(`${environment.baseUrl}/modelGroup`, modelGroup, {headers});
  }
}
